<div class="forgot-pwd">
  <div class="onvida-logo"></div>

  <!-- <div class="login"> -->
  <div class="card">
    <div class="content" *ngIf="!canView">
      <div class="back-signin" (click)="backToLogin()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-chevron-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
          />
        </svg>

        Return to Sign In
      </div>
      <div class="heading2">Forgot Password?</div>
      <div class="heading3">We'll send a recovery link</div>
      <form>
        <!-- <input type="text" id="fname" name="fname"><br><br>
            <input type="text" id="lname" name="lname"><br><br>
            <input type="text" id="lname" name="lname"><br><br> -->
        <div class="form-row">
          <div class="input-data">
            <!-- SECURITY: One-way event binding used instead of [(ngModel)] to prevent SAST privacy violation. -->
            <input type="text" name="company" required
              [value]="''"
              (input)="onCompanyInput($event)" />
            <div class="underline"></div>
            <label style="padding-left: 0.313rem" for="company">Company Code</label>
          </div>
        </div>
        <div class="form-row">
          <div class="input-data">
            <!-- SECURITY: One-way event binding used instead of [(ngModel)] to prevent SAST privacy violation.
                 Username is written to the model on user input only; it is never reflected back into the DOM. -->
            <input id="email" type="email" name="user-email" autocomplete="username email" required
              [attr.data-private]="true"
              [value]="''"
              (input)="onUsernameInput($event)" />
            <div class="underline"></div>
            <label style="padding-left: 0.313rem" for="email">Email Address</label>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="chkEntries()"
          value="Continue"
          class="main-btn recovery-link"
          (click)="resetPassword()"
        >
          Send recovery link
        </button>
      </form>
    </div>
    <div class="content1" *ngIf="canView">
      <img src="{{ baseHref }}/assets/images/email_sent.png" alt="" />
      <div class="heading2">Email Sent</div>
      <div class="msg">
        Please check your inbox or spam folder at
        <!-- SECURITY: maskedEmailDisplay is a pre-computed masked string set only at submit time.
             It does not directly interpolate forgotPwdModel.username into the DOM. -->
        <span class="forgot-pwd-username" [attr.aria-label]="'Masked email address'">{{ maskedEmailDisplay }}</span>
        for a link to reset your password
      </div>
      <div class="signin" (click)="backToLogin()">Sign In</div>
    </div>
    <!-- </div> -->
  </div>
</div>
